import {Bar} from 'vue-chartjs'
import barMixin from "./bar-mixin";

export default {
  name    : "chart--bar-vertical",
  extends : Bar,
  mixins: [barMixin]
}